import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';

export interface Options {
  pad?: boolean; // TODO: make this a string the CSS property 'padding' can receive
}
export interface Props extends Options {
  className?: string;
  toggleAccordionItem?: any;
  open?: boolean;
}

class Content extends React.Component<Props, {}> {
  public static defaultProps: Props = {
    open: false,
    pad: false,
  };

  public render() {
    const { children, className, open } = this.props;
    return (
      <div className={c(className, { open })}>
        {React.Children.map(children, child =>
          React.cloneElement(child as any, {
            handleToggleAccordion: this.props.toggleAccordionItem,
          }),
        )}
      </div>
    );
  }
}

export default styled(Content)`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 0;
  overflow: hidden;

  &.open {
    ${props => (props.pad ? { padding: '1.5em' } : {})};
    min-height: 3em;
  }
`;
